import { Tab, Tabs } from "@material-ui/core";
import * as React from "react";
import { THEME } from "../../theme/ThemeStore";
import { pushRoute } from "../app/router/history";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";

export type TabConfig<T> = {
    value: T;
    label: string;
    url: string;
};

type Props = {
    value: string;
    handleChange: (event: React.ChangeEvent<any>, newValue: string) => void;
    tabs: TabConfig<string>[];
};

export const TabBar = ({ value, handleChange, tabs }: Props) => {
    const isMobile = useMobileMediaQuery();

    return (
        <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            TabIndicatorProps={{ style: { height: 3 } }}
            style={{ marginBottom: 16 }}
        >
            {tabs.map((tab, index) => (
                <Tab
                    key={index}
                    value={tab.value}
                    label={tab.label}
                    onClick={() => pushRoute(tab.url)}
                    color="primary"
                    style={{
                        borderBottom: `1px solid ${THEME.customColors.dataUploadBorderColor}`,
                        marginBottom: 1
                    }}
                />
            ))}
            {!isMobile && (
                <Tab
                    style={{
                        borderBottom: `1px solid ${THEME.customColors.dataUploadBorderColor}`,
                        opacity: 1,
                        flexGrow: 1,
                        marginBottom: 1,
                        maxWidth: "unset"
                    }}
                    disabled
                />
            )}
        </Tabs>
    );
};
